export default __webpack_public_path__ + "static/media/img_20.79cf9a78.jpg";